export const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/
export const nameRegex = /^[A-Za-z\s'’\-0-9+_%.,—]+$/
export const mobileRegex = /^\+?[\(\)\d\s]{6,14}$/
export const numberRegex = /^\d+$/
export const postcodeRegex = /^\d{4}$/
